import styles from "./live-tournament-page.module.css"
import LiveTournamentsList from "./Live/LiveTornamentList"
import { useTheme } from "@/components/context/ThemeContext"

export default function LiveTournamentPage() {
  const { theme } = useTheme();

  return (
    <div className={`${styles.liveContainer} ${theme === 'dark' ? 'dark' : ''}`}>
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <h1 className={styles.title}>
            <span className={styles.liveBadge}>● LIVE</span>
            TOURNAMENTS
          </h1>
          <p className={styles.subtitle}>Watch epic matches, chat with spectators, and earn rewards</p>
        </div>
      </div>

      <LiveTournamentsList />
    </div>
  )
}
